import { Chart, type ChartProps } from 'primereact/chart';
import resolveConfig from 'tailwindcss/resolveConfig';
import themeColor from '../../../styles/colors.json';
import tailwindConfig from '../../../tailwind.config';

interface Props extends ChartProps {
	xTitle?: string;
	yTitle?: string;
}

const BarChart = (props: Props) => {
	const { options, xTitle, yTitle, ...rest } = props;

	const fullConfig = resolveConfig(tailwindConfig);

	const axesLabelStyle = {
		display: true,
		font: {
			size: 16,
			family: fullConfig.theme.fontFamily.poppins,
			weight: 600,
		},
		color: themeColor.primaryFixedDim,
		padding: 10,
	};

	const ticksStyleX = {
		display: true,
		font: {
			size: 8,
			family: fullConfig.theme.fontFamily.poppins,
			weight: 400,
			lineHeight: 2,
		},
		color: themeColor.secondary,
	};

	const ticksStyleY = {
		display: true,
		stepSize: 200,
		font: {
			size: 10,
			family: fullConfig.theme.fontFamily.poppins,
			weight: 400,
		},
		color: themeColor.chartTickY,
	};

	const legendStyle = {
		boxWidth: 24,
		boxHeight: 24,
		font: {
			size: 14,
			family: fullConfig.theme.fontFamily.poppins,
			weight: 600,
		},
		color: themeColor.neutral50,
		//TODO: fix padding between legend and chart
	};

	const optionsBarChart = options
		? options
		: {
				maintainAspectRatio: false,
				aspectRatio: 0.8,
				plugins: {
					legend: {
						position: 'top', // Legend BELOW chart
						align: 'start',
						display: true,
						labels: {
							...legendStyle,
						},
					},
				},
				scales: {
					x: {
						ticks: {
							...ticksStyleX,
						},
						grid: {
							display: false,
						},
						title: {
							text: xTitle,
							...axesLabelStyle,
						},
					},
					y: {
						min: 0,
						max: 1000,
						ticks: {
							...ticksStyleY,
						},
						grid: {
							display: false,
						},
						title: {
							text: yTitle,
							...axesLabelStyle,
						},
					},
				},
			};

	return <Chart {...rest} type="bar" options={optionsBarChart} />;
};

export default BarChart;
